export const ANALYTICS_PLATFORMS = {
  FACEBOOK: 'FACEBOOK',
  PINTEREST: 'PINTEREST',
};
